<main class="numeros">
  <header>
    <div><a routerLink="/admin/mia-gestor">Mia Gestor</a><h1>Número da Mia</h1>
      <p>Qual WhatsApp do MeuCardápio atende a implantação e o comercial, e quem pode falar com ela.</p></div>
    <button type="button" (click)="carregue()" [disabled]="carregando || salvando">{{ carregando ? 'Atualizando…' : 'Atualizar' }}</button>
  </header>

  <p class="erro" role="alert" *ngIf="erro">{{ erro }}</p>
  <p class="aviso" role="status" *ngIf="aviso">{{ aviso }}</p>

  <p class="situacao" *ngIf="!carregando">
    <ng-container *ngIf="atual">
      Hoje a Mia Gestor é <strong>{{ atual.telefone }}</strong>
      <small>({{ atual.nome }} · {{ atual.empresa?.nome }})</small>.
    </ng-container>
    <ng-container *ngIf="!atual && fallbackAmbiente">
      Nenhum número escolhido aqui. O servidor está usando o phone_number_id <code>{{ fallbackAmbiente }}</code> da variável de ambiente.
    </ng-container>
    <ng-container *ngIf="!atual && !fallbackAmbiente">
      Nenhum número é a Mia Gestor. Mensagens de implantação e comerciais não são atendidas.
    </ng-container>
  </p>

  <div class="layout">
    <aside aria-label="Números cadastrados">
      <label for="busca-numero">Buscar número</label>
      <input id="busca-numero" [(ngModel)]="filtro" placeholder="Nome, telefone, id ou empresa">
      <p class="vazio" *ngIf="!numeros.length && !carregando">Nenhum número Cloud cadastrado.</p>
      <p class="vazio" *ngIf="numeros.length && !filtrados.length">Nenhum número para esta busca.</p>
      <button class="numero" type="button" *ngFor="let n of filtrados" (click)="escolha(n)"
              [class.selecionado]="n.id === escolhidoId" [disabled]="salvando"
              [attr.aria-pressed]="n.id === escolhidoId">
        <strong>{{ n.telefone }}</strong>
        <span>{{ n.nome }}</span>
        <small>{{ n.empresa?.nome }} · id {{ n.whatsappId }}</small>
        <span class="selo" *ngIf="n.miaGestor">Mia Gestor</span>
      </button>
    </aside>

    <section class="detalhe" aria-live="polite">
      <p class="vazio" *ngIf="!escolhido">Escolha na lista o número que será a Mia Gestor.</p>
      <ng-container *ngIf="escolhido">
        <h2>{{ escolhido.telefone }}</h2>
        <p>{{ escolhido.nome }} · empresa {{ escolhido.empresa?.nome }} · phone_number_id {{ escolhido.whatsappId }}</p>

        <fieldset>
          <legend>Quem pode conversar com a Mia comercial</legend>
          <label class="opcao">
            <input type="radio" name="quem" value="todos" [(ngModel)]="quemConversa" [disabled]="salvando">
            <span><strong>Todo mundo</strong><small>Qualquer contato que mandar mensagem entra no atendimento comercial.</small></span>
          </label>
          <label class="opcao">
            <input type="radio" name="quem" value="lista" [(ngModel)]="quemConversa" [disabled]="salvando">
            <span><strong>Somente estes números</strong><small>Um por linha, com DDI. Coloque também a variante sem o nono dígito.</small></span>
          </label>
          <textarea *ngIf="quemConversa === 'lista'" rows="5" [(ngModel)]="lista" [disabled]="salvando"
                    placeholder="5562982301144&#10;556282301144" aria-label="Números liberados"></textarea>
        </fieldset>

        <p class="orientacao">A implantação por convite continua funcionando para qualquer contato com link válido, independente desta escolha.</p>

        <div class="acoes">
          <button type="button" class="primario" (click)="salve()" [disabled]="salvando || !mudou">
            {{ salvando ? 'Salvando…' : (escolhido.miaGestor ? 'Salvar' : 'Tornar este o número da Mia') }}
          </button>
          <button type="button" *ngIf="escolhido.miaGestor" (click)="desligue()" [disabled]="salvando">Deixar de ser a Mia</button>
        </div>
      </ng-container>
    </section>
  </div>
</main>
